import { Typography } from "@material-ui/core";
import UtfCode from "../../../../app/util/UtfCode";
import AppInitSingletonBo from "../../../../consumer/init/AppInitSingletonBo";
import ContentArea from "../../../cmp/content/ContentArea";
import useWizardFormCtx from "../ctx-provider/useWizardFormCtx";

const KontaktAgentur: React.FC = () => {
    const agtName1 = AppInitSingletonBo.vermittler?.agtName1;
    const agtTelefon = AppInitSingletonBo.vermittler?.agtTelefon;

    return (
        <div style={{ textAlign: 'center', marginTop: 30 }}>
            {agtName1 && <Typography variant='body1' color='textPrimary'>{agtName1}</Typography>}
            {agtTelefon && <Typography variant='body2' color='textPrimary'>{agtTelefon}</Typography>}
            <Typography variant='caption' color='textPrimary'>Mo-Fr von 8:00 - 16:00 Uhr</Typography>
        </div>);
}

const Page: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    const antrag = wizardFormBo.antrag;

    const vnName = antrag.vnName ? antrag.vnName : '';
    const vnVorname = antrag.vnVorname ? antrag.vnVorname : '';

    const renderAgentur = AppInitSingletonBo.renderAgentur();

    return (
        <ContentArea>
            <div style={{ textAlign: 'center', marginTop: 60 }}>
                <Typography variant='h1' color='textPrimary'>Vielen Dank für Ihr Vertrauen,<br /><b> {`${vnVorname}${UtfCode.NO_BREAK_SPACE}${vnName}`}!</b></Typography>
                <Typography variant='h6' color='textPrimary'
                    style={{ marginTop: 10 }}>
                    {`Ihre Vertragsunterlagen erhalten Sie in den nächsten Tagen per Post.`}</Typography>

            </div>
            <div style={{ textAlign: 'center', marginTop: 30 }}>
                <Typography variant='h4' color='textPrimary'>Haben Sie weitere Fragen?</Typography>
                <Typography variant='h6' color='textPrimary'>Melden Sie sich gerne bei uns.</Typography>
            </div>
            {renderAgentur && <KontaktAgentur />}

        </ContentArea>
    );
}

export default Page;